import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { SliderDesigners } from './slider-designers'
import { Title } from './styled'

export const Designers = forwardRef<HTMLDivElement>((_, ref) => (
  <section ref={ref}>
    <TextContainer>
      <Title data-menu-title="современные дизайнеры">
        Современные дизайнеры
      </Title>
    </TextContainer>

    <SliderDesigners />
  </section>
))
